import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
// import {  provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideTranslateService,TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { MsalModule } from '@azure/msal-angular';
import { APP_INITIALIZER } from '@angular/core';
import { initializeMsal } from './msal-init.factory';
import { MsalService } from '@azure/msal-angular';
import { 
  msalInstance,
  msalGuardConfig,
  msalInterceptorConfig
} from './msal-config';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalInterceptor } from '@azure/msal-angular';
import {
  withInterceptors,
  provideHttpClient,
  withInterceptorsFromDi,
  withFetch
} from '@angular/common/http';
import { HttpClient } from '@angular/common/http';

import { loaderInterceptor } from './interceptors/loader.interceptor';
import {authInterceptor} from './interceptors/auth.interceptor';
// import { HttpLoaderFactory } from './loader-factory';

export const appConfig: ApplicationConfig = {
  providers: [ 
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      deps: [MsalService],
      multi: true
    },
    importProvidersFrom(
      MsalModule.forRoot(msalInstance, msalGuardConfig, msalInterceptorConfig)
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // FIX: provideHttpClientの重複を修正 (2026/01/06)
    // 以前は2箇所で宣言されており、withFetch()が上書きされていた
    // これによりPOSTリクエストのボディが空で送信される問題が発生
    // 1つのprovideHttpClientにすべてのオプションをまとめる
    provideHttpClient(
      withInterceptorsFromDi(),     // DIベースのインターセプター
      withFetch(),                   // Fetch APIを使用（Angular 17+推奨）
      withInterceptors([loaderInterceptor, authInterceptor])  // 関数型インターセプター
    ),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      })
    }),
    provideRouter(routes),
    provideAnimationsAsync(),
    // provideHttpClient(withInterceptors([])),
    // importProvidersFrom(TranslateModule.forRoot({
    //     defaultLanguage: 'en',
    //     loader: {
    //       provide: TranslateLoader,
    //       // useFactory: HttpLoaderFactory,
    //       deps: [HttpClient]
    //     }
    //   }))
  ]
};
